/**
 * All types in this file are used in the style state feature.
 * Copied to avoid circular dependencies.
 */
export type OverrideTarget = 'tablet' | 'mobile';

export const ALL_OVERRIDE_TARGETS: OverrideTarget[] = ['tablet', 'mobile'];

export interface PropsWithOverrides<P extends object | undefined = object> {
  props: P;
  overrides?: PropsOverrides;
}

export type PropsOverrides<P extends object | undefined = object> = {
  [key in OverrideTarget]?: { props?: P };
};
